import React from 'react';
import LaunchIcon from '@mui/icons-material/Launch';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import BaseIconButton, { IBaseIconButtonProps } from './_module/BaseIconButton';

interface IProps extends IBaseIconButtonProps {
  iconFontSize?: SvgIconTypeMap['props']['fontSize'];
  iconHtmlFontSize?: string;
}

export default function ExternalLinkIconButton(props: IProps) {
  const {
    onClick,
    size,
    iconFontSize,
    tooltip,
    href,
    target,
    htmlColor,
    iconHtmlFontSize,
  } = props;

  return (
    <BaseIconButton
      onClick={onClick}
      tooltip={tooltip}
      href={href}
      target={target}
      size={size || 'small'}
    >
      <LaunchIcon
        fontSize={iconFontSize || 'small'}
        style={{ fontSize: iconHtmlFontSize }}
        htmlColor={htmlColor}
      />
    </BaseIconButton>
  );
}
